/* Base */

/*
 * Containment lives on a host element rather than on the block itself: a
 * container query cannot style its own container, and the narrow layout has to
 * switch `flex-wrap` on the row.
 */
.eds-file-input--host {
  container-name: eds-file-input;
  container-type: inline-size;
}

.eds-file-input {
  --_edge: var(--eds--color--border-input-default);
  --_surface: var(--eds--color--bg-muted-soft);
  align-items: center;
  background: var(--_surface);
  border: var(--eds--size-1) dashed var(--_edge);
  border-radius: var(--eds--radii-8);
  box-sizing: border-box;
  display: flex;
  flex-wrap: nowrap;
  gap: var(--eds--spacing-8);
  justify-content: center;
  padding: var(--eds--padding-12) var(--eds--padding-16);
  width: 100%;
}

.eds-file-input--prompt {
  align-items: center;
  display: flex;
  flex: 0 1 auto;
  gap: var(--eds--spacing-8);
  min-width: 0;
}

.eds-file-input--instructions {
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.eds-file-input--hint {
  margin-inline-start: var(--eds--spacing-4);
}

.eds-file-input--separator {
  flex: none;
  text-transform: uppercase;
}

/* States */

.eds-file-input--drag-active {
  --_edge: var(--eds--color--border-brand);
}

.eds-file-input--disabled {
  cursor: not-allowed;
  opacity: var(--eds--opacity-disabled);
}

.eds-file-input--critical {
  --_edge: var(--eds--color--border-critical);
  --_surface: var(--eds--color--bg-critical-soft);
}

.eds-file-input--cautious {
  --_edge: var(--eds--color--border-cautious);
  --_surface: var(--eds--color--bg-cautious-soft);
}

/* Narrow containers — two rows: icon and instructions above, separator and
   upload button below. Both rows stay centered. */

@container eds-file-input (max-width: 420px) {
  .eds-file-input {
    flex-wrap: wrap;
  }

  /* Full basis takes the first row on its own; the separator and button then
     pack onto the second. */
  .eds-file-input--prompt {
    flex-basis: 100%;
    justify-content: center;
  }

  .eds-file-input--instructions {
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
  }
}
